import React from "react";
import { Badge } from "@/shared/components/ui/badge";
import { Button } from "@/shared/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { Key, Eye, EyeOff, Webhook } from "lucide-react";

export default function SettingsTab({ merchant, showApiKey, setShowApiKey, t }) {
  const settingsFields = [
    { label: t ? t("contactEmail") : "Contact Email", value: merchant?.email || "N/A", breakAll: true },
    { label: t ? t("merchantCode") : "Merchant Code", value: merchant?.code || "N/A" },
    { label: t ? t("settlementPeriod") : "Settlement Period", value: merchant?.settlementPeriod || "N/A" },
    { label: t ? t("callbackUrl") : "Callback URL", value: merchant?.callbackUrl || "N/A", breakAll: true, small: true },
    { label: t ? t("webhookUrl") : "Webhook URL", value: merchant?.webhookUrl || "N/A", breakAll: true, small: true },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* API Keys */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Key className="h-5 w-5" />
            {t ? t("apiCredentialsTitle") : "API Credentials"}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <p className="text-sm text-slate-500 mb-2">{t ? t("apiKeyPublic") : "API Key"}</p>
            <div className="flex items-center gap-2">
              <code className="flex-1 bg-slate-100 px-3 py-2 rounded-lg font-mono text-sm">
                {showApiKey ? (merchant?.secretKey || (t ? t("nA") : "Not set")) : "••••••••••••••••"}
              </code>
              <Button variant="outline" size="icon" onClick={() => setShowApiKey(!showApiKey)}>
                {showApiKey ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Merchant Settings */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Webhook className="h-5 w-5" />
            {t ? t("settings") : "Settings"}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {settingsFields.map((field) => (
            <div key={field.label}>
              <p className="text-sm text-slate-500 mb-1">{field.label}</p>
              <p className={`${field.small ? "text-sm" : "font-medium"} ${field.breakAll ? "break-all" : ""}`}>
                {field.value}
              </p>
            </div>
          ))}
          <div>
            <p className="text-sm text-slate-500 mb-1">{t ? t("ipWhitelist") : "IP Whitelist"}</p>
            {merchant?.ipWhitelistEntries?.length ? (
              <div className="space-y-1">
                {merchant.ipWhitelistEntries.map((entry) => (
                  <p key={entry.ip} className="text-sm">{entry.ip} ({entry.statusIp})</p>
                ))}
              </div>
            ) : (
              <p className="text-sm">N/A</p>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
